import { z } from "zod";
import { BaseAnalyticsEvent } from "./base";
export const Campaign_Create = BaseAnalyticsEvent.extend({
    name: z.literal("Campaign_Create")
});
export const Campaign_TriggerUpdate = BaseAnalyticsEvent.extend({
    name: z.literal("Campaign_TriggerUpdate"),
    properties: z.object({
        action: z.enum([
            "remove",
            "add",
            "enable",
            "disable"
        ])
    })
});
export const Campaign_RuleUpdate = BaseAnalyticsEvent.extend({
    name: z.literal("Campaign_RuleUpdate"),
    properties: z.object({
        action: z.enum([
            "update",
            "pause",
            "enable",
            "re-order",
            "copy"
        ])
    })
});
export const Campaign_RuleAdd = BaseAnalyticsEvent.extend({
    name: z.literal("Campaign_RuleAdd")
});
export const Campaing_VariantUpdate = BaseAnalyticsEvent.extend({
    name: z.literal("Campaign_VariantUpdate"),
    properties: z.object({
        action: z.enum([
            "add",
            "remove",
            "update-weights",
            "reset-assignments"
        ])
    })
});
export const Campaign_ChartView = BaseAnalyticsEvent.extend({
    name: z.literal("Campaign_ChartView")
});
